import { ResursTreeApi } from '../../../services/modules/tree';
import { TResursTreeNode } from '../treeTypes';

export const handleDelete = (
  treeName: ResursTreeApi.treeName,
  nodes: TResursTreeNode[]
) => {
  ResursTreeApi.delObject({
    tree: treeName,
    objects: nodes.map((node) => {
      return {
        objectId: +node.id,
        parentId: node.parent,
      };
    }),
  });
};
